"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_compose_1 = require("graphql-compose");
const addVLDirectives_1 = __importDefault(require("./builders/addVLDirectives"));
const addVLScalars_1 = __importDefault(require("./builders/addVLScalars"));
exports.default = (schemaSdl) => {
    const composer = new graphql_compose_1.SchemaComposer();
    addVLDirectives_1.default(composer);
    addVLScalars_1.default(composer);
    composer.addTypeDefs(schemaSdl);
    return composer;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlVkxDb21wb3Nlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jbXMvc2NoZW1hL2NyZWF0ZVZMQ29tcG9zZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxxREFBaUQ7QUFDakQsaUZBQXlEO0FBQ3pELDJFQUFtRDtBQUVuRCxrQkFBZSxDQUFDLFNBQWlCLEVBQUUsRUFBRTtJQUNuQyxNQUFNLFFBQVEsR0FBRyxJQUFJLGdDQUFjLEVBQUUsQ0FBQztJQUN0Qyx5QkFBZSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQzFCLHNCQUFZLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDdkIsUUFBUSxDQUFDLFdBQVcsQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUNoQyxPQUFPLFFBQVEsQ0FBQztBQUNsQixDQUFDLENBQUMifQ==